import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetWorkshop {
  success: boolean,
  message: string,
  result: {
    workshop_data: [
      {
        WORKSHOP_ID: string,
        WORKSHOP_NAME: string,
        COUNT_REGISTED: number,
        SUM_PRICE: number
      },
    ]
    consult_data: [
      {
        CONSULT_ID: string,
        CONSULT_TYPE: string,
        COUNT_REGISTED: number,
        SUM_PRICE: number
      },
    ]
  }
}

interface resGetMeasure {
  success: boolean,
  message: string,
  result: [
    {
      MEASURE_ID: string,
      MEASURE_NAME: string,
      COUNT_REGISTED: number,
      SUM_PRICE: number
    }
  ]
}

interface resGetCourse {
  success: boolean,
  message: string,
  result: [
    {
      COURSE_ID: string,
      COURSE_NAME: string,
      COUNT_REGISTED: number,
      SUM_PRICE: number
    }
  ]
}

@Injectable({
  providedIn: 'root'
})
export class FinancialListService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getWorkshop(workshop) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetWorkshop>(environment.URL + '/payment/getOverAllPaymentByType?TYPE=' + workshop, { headers: headers });
  }

  getCourse(course) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetCourse>(environment.URL + '/payment/getOverAllPaymentByType?TYPE=' + course, { headers: headers });
  }

  getMeasure(measure) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetMeasure>(environment.URL + '/payment/getOverAllPaymentByType?TYPE=' + measure, { headers: headers });
  }
}
